import { getStore } from '../store/store';

export function getSavedCalendarView(id: string | null) {
    if (id == null) {
        return undefined;
    }

    return getStore().savedViewMap.get(id);
}

export function getSavedCalendarViewsMap() {
    return getStore().savedViewMap;
}

export function getCurrentlyDisplayedViewId() {
    return getStore().currentlyDisplayedViewId;
}

export function hasCurrentlyDisplayedView() {
    return getStore().currentlyDisplayedViewId != null ? true : false;
}

export function isStoreLoaded() {
    return getStore().isLoaded;
}

export function getUpdatedSavedViewIds() {
    return getStore().updatedSavedViewIds;
}
